import { getGASessionParams } from '@/helpers/analitics';
import { http, getCsrfToken } from './index';

type HttpError = {
  name: string;
  message: string;
};

type HttpEmailError = {
  username: string[];
  email: string[];
};

type AuthBase = {
  success: boolean;
  data: {
    csrf_token: string;
  };
  errors: HttpError[];
};

type EmailBase = {
  success: boolean;
  redirect: string;
  errors: HttpEmailError;
};

export type LoginParamsBase = {
  email: string;
  password: string;
};

export type SignUpParamsBase = {
  email: string;
  password: string;
  firstname: string;
  lastname: string;
  phone: string;
};

type UserPhoneParamsBase = {
  phone: string;
};

export type UserEmailParamsBase = {
  email: string;
  url: string;
};

type SignUpWithGoogleBase = {
  token: string;
};

type SignUpWithAppleBase = {
  token: string;
  code: string;
};

type SignUpGoogleAppleResponse = {
  email: string;
  csrf_token: string;
};

export async function login(params: LoginParamsBase) {
  return http<AuthBase>({
    headers: {
      'Content-Type': 'application/json',
    },
    method: 'POST',
    url: '/auth/login/',
    data: JSON.stringify({
      ...params,
      ...getCsrfToken(),
      ...getGASessionParams(),
    }),
  });
}

export async function signUp(params: SignUpParamsBase) {
  return http<AuthBase>({
    headers: {
      'Content-Type': 'application/json',
    },
    method: 'POST',
    url: '/auth/registration/',
    data: JSON.stringify({
      ...params,
      ...getCsrfToken(),
      ...getGASessionParams(),
    }),
  });
}

export async function saveUserPhone(params: UserPhoneParamsBase) {
  return http<AuthBase>({
    headers: {
      'Content-Type': 'application/json',
    },
    method: 'POST',
    url: '/auth/user-phone/',
    data: JSON.stringify({
      ...params,
      ...getCsrfToken(),
      ...getGASessionParams(),
    }),
  });
}

export async function apiSaveUserEmail(params: UserEmailParamsBase) {
  return http<EmailBase>({
    headers: {
      'Content-Type': 'application/json',
    },
    method: 'POST',
    url: params.url,
    data: JSON.stringify({
      ...params,
      ...getCsrfToken(),
      ...getGASessionParams(),
    }),
  });
}

export async function SignUpWithGoogle(params: SignUpWithGoogleBase) {
  return http<SignUpGoogleAppleResponse>({
    headers: {
      'Content-Type': 'application/json',
    },
    method: 'POST',
    url: '/auth-provider/signup-with-google/',
    data: JSON.stringify({
      ...params,
      ...getCsrfToken(),
      ...getGASessionParams(),
    }),
  });
}

export async function SignUpWithApple(params: SignUpWithAppleBase) {
  return http<SignUpGoogleAppleResponse>({
    headers: {
      'Content-Type': 'application/json',
    },
    method: 'POST',
    url: '/auth-provider/signup-with-apple/',
    data: JSON.stringify({
      ...params,
      ...getCsrfToken(),
      ...getGASessionParams(),
    }),
  });
}
